import React from "react";

import "./styles.scss";

import { Container, Row, Col } from "reactstrap";
import ProgramSpecs from "../../components/ProgramSpecs/ProgramSpecs";
import Goals from "../../components/Goals/Goals";
import ProgramBanner from "../../components/ProgramBanner/ProgramBanner";
import LearningModule from "../../components/LearningModule/LearningModule";

const DiploMarketingComu = () => {
    const programs = [
        {
            key: 'FORMATO',
            title: 'Formato',
            content: '100% online, con clases virtuales semanales en vivo',
        },
        {
            key: 'ACCESO_CV',
            title: 'Acceso al campus virtual',
            content: 'las 24 horas',
        },
        {
            key: 'IDIOMA',
            title: 'Idioma',
            content: 'español',
        },
        {
            key: 'DURACION',
            title: 'Duración',
            content: '2 meses',
        },
        {
            key: 'FECHA_INICIO',
            title: 'Fecha de inicio',
            content: 'a definir',
        },
        {
            key: 'DIA_Y_HORA',
            title: "Día y horario",
            content: 'Lunes de 20 a 21hs (horario de España)' ,
        },
        {
            key: 'PROYECTOS',
            title: 'Proyectos',
            content: 'prácticos en clubes de fútbol',
        },
        {
            key: 'CASOS',
            title: 'Casos',
            content: 'de estudio reales',
        }
    ];

    const goals = [
        {
            key: 'VISION',
            content: 'Proporcionar una visión integral sobre el papel estratégico de la comunicación y el marketing digital en el fútbol y los negocios relacionados.',
        },
        {
            key: 'CAPACITAR',
            content: 'Capacitar a los participantes en las últimas tendencias globales, asegurando que estén siempre actualizados para afrontar los desafíos del sector.',
        },
        {
            key: 'HERRAMIENTAS',
            content: "Dotar al alumnado de herramientas prácticas y conocimientos especializados para desempeñarse con éxito en roles vinculados a la comunicación, tanto en clubes de fútbol como en empresas de la industria.",
        },
        {
            key: 'CASOS',
            content: 'Presentar casos de estudio concretos y reales, permitiendo a los estudiantes aplicar sus aprendizajes en contextos prácticos.',
        }
    ];

    const modules = [
        {
            moduleTitle: 'MÓDULO I',
            title: 'Introducción al Mundo Digital',
            content: [
                'La transformación digital en el fútbol y su impacto en el día a día.',
                'Razones clave para apostar por la comunicación digital.',
                'Estadísticas relevantes del ecosistema digital.',
                'Introducción al desarrollo de una estrategia digital efectiva.'
            ]
        },
        {
            moduleTitle: 'MÓDULO II',
            title: 'Comunicación Digital',
            content: [
                'Diferencias clave entre la comunicación digital y la tradicional.',
                'Nuevos paradigmas en la comunicación digital.',
                'Desarrollo de tono, voz y definición de audiencias.',
                'Estrategias para plataformas digitales.',
                'Gestión de crisis: cómo actuar y monitorear resultados.',
            ]
        },
        {
            moduleTitle: 'MÓDULO III',
            title: 'Digital Comercial',
            content: [
                'Estrategias para monetizar la comunicación digital.',
                'Funnel de conversión y segmentación de audiencias.',
                'Customer Journey Map aplicado al fútbol.',
                'Branded Content y su importancia.',
                'El rol del Media Kit.',
                'Sponsoreo y maximización de audiencias.',
            ]
        },
        {
            moduleTitle: 'MÓDULO IV',
            title: 'Análisis de Datos',
            content: [
                'Qué son los datos y su utilidad estratégica.',
                'La importancia de ser data-driven en el deporte.',
                'Herramientas para la recolección, análisis y visualización de datos.',
                'Tipos de datos a recolectar: métricas de vanidad vs. métricas accionables.'
            ]
        },
        {
            moduleTitle: 'MÓDULO V',
            title: 'Generación de Contenido',
            content: [
                'El modelo de entretenimiento en la generación de contenido.',
                'Producción de contenido en clubes de fútbol.',
                'Media house: formatos y casos de éxito.'
            ]
        },
        {
            moduleTitle: 'MÓDULO VI',
            title: 'Sitio Web, SEO y SEM',
            content: [
                'Rol estratégico del SEO y SEM.',
                'Herramientas online para desarrollar estrategias efectivas.',
                'Buenas prácticas en posicionamiento digital.',
                'La importancia del sitio web como herramienta central.',
                'Tipos de sitios web según objetivos estratégicos.',
            ]
        },
        {
            moduleTitle: 'MÓDULO VII',
            title: 'OTT (Over-The-Top)',
            content: [
                'Características principales de las plataformas OTT.',
                'Ventajas y desventajas de su implementación en el deporte.',
                'Modelos de monetización para OTT.',
                'Tipos de plataformas y recomendaciones para'
            ]
        },
        {
            moduleTitle: 'MÓDULO VIII',
            title: 'Web 3 y Metaverso',
            content: [
                'Introducción al concepto de Web 3.',
                'Ventajas y desafíos de la Web 3 en la industria deportiva.',
                'Blockchain: aplicaciones y potencial en el deporte.',
                'NFTs y su rol en la interacción con los aficionados.',
                'Introducción al metaverso: oportunidades y ejemplos concretos en el deporte.',
            ]
        }
    ];

    const speakers = [
        {
            name: 'Socios.com',
            image: 'socios'
        },
        {
            name: 'AUF',
            image: 'auf'
        },
        {
            name: 'CA',
            image: 'ca'
        },
        {
            name: 'River Plate',
            image: 'river'
        },
        {
            name: 'AFA',
            image: 'afa'
        }
    ];

    return (
        <>
            {
                <ProgramBanner
                    title="Diplomatura en Marketing y Comunicación"
                    description={[
                        "El marketing y la comunicación digital se han convertido en pilares fundamentales de la industria del fútbol. Son herramientas clave para conquistar nuevas audiencias, fortalecer la conexión con los aficionados y maximizar los ingresos comerciales.",
                        "La diplomatura está pensada para profesionales que quieran desarrollar su carrera profesional en el área de comunicación o marketing de algún club o institución relacionada a la industria del fútbol.  El programa está desarrollado tanto para personas que no tengan conocimientos en marketing o comunicación, como también para aquellos que quieran profundizar sobre las últimas tendencias en la industria.",
                    ]}
                    video="EENc1zYhjlI"
                    link="Marketing-Comunicacion-digital"
                    bgColor="blue"
                />
            }
            {<ProgramSpecs programs={programs}/>}
            {<Goals goals={goals} bgColor="gold" />}
            {<LearningModule modules={modules} bgColor="blue" />}

            <Container fluid tag="section" className="program-sponsors py-5">
                <Container>
                    <Row tag="article">
                        <Col xs="12" className="text-center">
                            <h2 className="title">Ponentes de las siguientes instituciones</h2>
                        </Col>
                        <Col className="text-center pt-4">
                            {speakers.map((speaker, index) => (
                                <img src={`/images/logos/${speaker.image}.png`} alt={speaker.name} title={speaker.image} className="img-fluid" />
                            ))}
                        </Col>
                    </Row>
                </Container>
            </Container>
        </>
    );
};

export default DiploMarketingComu;